import React, { Component } from 'react';
import { fileKey, fileUrl } from '../../../../../util/file_url';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
export default class AudioPlayer extends Component {
    render() {
        const customRenderItem = (item, props) => <item.type {...item.props} {...props} />;
        const audioFiles = this.props.files.map(file => {
            let filePath = file.path
            return <div>
                <video preload="metadata"
                    src={fileUrl(fileKey(file))} controls />
                    <p className="legend">{filePath}</p>
            </div>
        })
        return (
            <Carousel 
                renderItem={customRenderItem} >
            {/* // renderThumbs={customRenderThumb}> */}
                {audioFiles}
            </Carousel>
        );
    }
};